import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black border-t border-[#2a2a2a] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src="/logo.png" alt="IVE — Ironveil Era" className="h-12 w-auto" data-testid="footer-logo" />
          <div className="divider-red mt-4 mb-6" />
          <p className="text-[#a0a0a0] max-w-md text-sm leading-relaxed">
            Building the future of combat sports. A modern combat-sports organization from India — starting with MMA and Boxing.
          </p>
          <div className="mt-6 font-display text-3xl sm:text-[34px] leading-none">Built for Combat.<br/>Built for <span className="text-[#C8102E]">Legacy.</span></div>
        </div>
        <div>
          <div className="type-label text-[#888] mb-4">Navigate</div>
          <ul className="space-y-3 text-sm">
            {["Home","Events","Records","Partners","About","Register"].map((l) => (
              <li key={l}><Link to={l === "Home" ? "/" : `/${l.toLowerCase()}`} className="hover:text-[#C8102E] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="type-label text-[#888] mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="text-[#a0a0a0]">Noida, Uttar Pradesh, India</li>
            <li><a href="mailto:hello@ironveilera.com" className="hover:text-[#C8102E]">hello@ironveilera.com</a></li>
            <li><Link to="/privacy" className="hover:text-[#C8102E]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#C8102E]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2a2a2a]">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-[#666]">
          <div>© {year} Ironveil Era Sports Private Limited</div>
          <div className="type-meta">IVE · India</div>
        </div>
      </div>
    </footer>
  );
}
